<template>
  <div
    class="import-block main__light_green"
    data-qa="import-docs-block">
    <div>
      <slot name="label"/>
      <div
        id="dropFile"
        ref="dropFile"
        class="dropFile h7-text"
        data-qa="drop-docs-block"
        :style="inlineStyle">
        <div class="col-9 text-center">
          <div>
            {{ multiple ? $t('Tenders.DropFile') : $t('Tenders.DropFileSingle') }}
            <sButton
              class="h7-text text-decoration-underline text-lowercase"
              data-qa="import-docs-btn"
              :disabled="disabled"
              small
              type="text"
              @click="importItem">
              {{ $t('Tenders.Import') }}
            </sButton>
            {{ multiple ? $t('Tenders.FromPC') : $t('Tenders.FromPCSingle') }}
            {{ $t('Tenders.FilesSize', {size: checked_file_size}) }}
          </div>
          <div data-qa="import-docs-types">
            {{ filesTypesText }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="files && files.length"
      style="font-size: 0.875rem; line-height: 1.375rem;">
      <DocumentList
        :attachments.sync="files"
        :can_view="preview"
        data-qa="imported-docs-list"
        :disabled="disabled && disabled_list"
        :external-delete="externalDelete"
        in_creating
        :new-endpoints="newEndpoints"
        @deleteFile="deleteFile"
        @restoreFile="restoreFile"/>
    </div>
  </div>
</template>
<script>
import DocumentList from 'components/common/blocks/DocumentList.vue'

import { CommonFile, allFileTypesNames } from '@/types/commonFile.js'

export default {
  name: 'importBlock',
  data() {
    return {
      disabledTypes: [
        'html', 'htm', 'js', 'php', 'php3', 'php4', 'php5', 'phtml',
        'shtml', 'asp', 'aspx', 'jsp', 'css', 'xml', 'json', 'pl', 'cgi', 'py',
        'rb', 'sh', 'swf', 'ps', 'exe', 'dll', 'ocx', 'sys',
      ],
      dialog: false,
      //files: [],
      load: false,
      dragAndDropCapable: true,
      addedFile: 0,
      addedFiles: []
    }
  },
  props: {
    files: Array,
    filesTypes: {
      type: [Array, Boolean],
      default: () => {
        return [
          'pdf',
          'png', 'jpeg', 'jpg', 'bmp', 'gif' , // img
          'rtf', 'csv', 'tiff' , // iframe
          'xls', 'xlsx', 'xlsb', 'xlsm',  //Excel
          'doc', 'docx', 'docm', 'dotm', 'dotx',  //Word
          'ppt', 'pptx', 'ppsx', 'pps', 'pptm', 'potm', 'ppam', 'potx', 'ppsm']
      }
    },
    preview: {
      type: Boolean,
      default: true
    },
    createFileHandler: { type: Function, required: true },
    addFiles: { type: Function },
    disabled: Boolean,
    disabled_list: {
      type: Boolean,
      default: true
    },
    multiple: { type: Boolean, default: () => true },
    file_size: {
      type: [Number, String],
    },
    inlineStyle: {
      type: String,
      default: 'width: 624px;'
    },
    /**
     * Есть ситуации когда нужны все типы + пару штук.
     * Если добавить эти пару штук в ошбий объект allFileTypesNames то они отобразятся там, где filesTypes: true
     */
    allFileTypes: Object,
    newEndpoints: Boolean,
    /**
    * Внешнее удаление файла
    */
    externalDelete: Boolean,
  },
  computed: {
    checked_file_size() {
      let can = this.$can('upload', 'incrementedFileSize')
      return this.file_size || (can ? 100 : 50)
    },
    filesTypesText() {
      let names
      if (Array.isArray(this.filesTypes)) {
        names = this.filesTypes.length > 1 ? this.filesTypes : []
      } else if (this.filesTypes) {
        names = Object.keys(this.allFileTypes || allFileTypesNames)
      } else {
        names = []
      }
      return names.join(', ')
    },
    fileTypesItems() {
      let types
      if (Array.isArray(this.filesTypes) &&  this.filesTypes.length) {
        types = this.filesTypes.map(type => (this.allFileTypes || allFileTypesNames)[type])
      } else if (this.filesTypes) {
        types = Object.values(this.allFileTypes || allFileTypesNames)
      } else {
        types = []
      }
      return types.join(', ')
    }
  },
  watch: {
    addedFiles(files) {
      let t = this
      files.forEach(file => {
        if (!t.files[file.id]) {
          t.$set(t.files, `${file.id}`, file)
        }
      })
    }
  },
  mounted() {
    //this.dragAndDropCapable = this.determineDragAndDropCapable()
    const checkDraggableZone = function(element) {
      if (element.id === 'dropFile') {
        return true
      }
      return element.parentElement ? checkDraggableZone(element.parentElement) : false
    }

    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function(evt) {
        document.body.addEventListener(evt, function(e) {
          e.preventDefault()
          e.stopPropagation()
          if (!checkDraggableZone(e.target)) {
            e.dataTransfer.effectAllowed = 'none'
            e.dataTransfer.dropEffect = 'none'
          }
        }.bind(this), false)
      }.bind(this))

      // DROP
      this.$refs.dropFile?.addEventListener('drop', function(e) {
        if (this.disabled) {
          return
        }
        if (!e?.dataTransfer?.files) {
          return
        }

        let files = [...e.dataTransfer.files]
        if (!this.multiple) {
          files = [files[0]]
        }

        const result = this.$_.cloneDeep(this.files)
        files = files.map(el => {
          let valid = this.validateFile(el)
          if (valid) {
            this.$show_error_message(valid)
            return this.$log_error(valid)
          }
          let file = this.createFileHandler(el)

          result.push(file)
          return file
        })
        this.$emit('update:files', result)
        if (this.addFiles) {
          this.addFiles(files)
        }

      }.bind(this))
    }
  },
  methods: {
    determineDragAndDropCapable() {
      let div = document.getElementById('dropFile') //document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    },
    validateFile(file) {
      if (!file) {
        return this.$t('Common.NotSelectedFile')
      }
      if (file.size > (this.checked_file_size * 1024 * 1024)) {
        return this.$t('Common.InvalidFileSize', { filesize: this.checked_file_size })
      }
      let types = this.filesTypesText.split(', ')
      let file_type = CommonFile.GetFileExtention(file.name).toLowerCase()
      if (this.disabledTypes.includes(file_type)) {
        return this.$t(`Тип файлу ${file_type} заборонено до завантаження`)
      }
      if (this.filesTypesText && !types?.some(ftype => ftype.includes(file_type))) {
        return this.$t('Common.InvalidFileType', { filetypes: types  })
      }
      return ''
    },
    importItem() {
      const input = document.createElement('input')
      input.type = 'file'
      if (this.multiple) {
        input.setAttribute('multiple', true)
      }
      input.accept = this.fileTypesItems
      input.style.display = 'none'

      input?.addEventListener('change',() => {
        const files = [...input.files]
        if (!files?.length) {
          return
        }
        setTimeout(function() {
          document.body.removeChild(input)
        }, 0)
        const result = this.$_.cloneDeep(this.files)
        let new_files = files.map(file => {

          const newName = file.name.replaceAll('|', '_')
          file = new File([file], newName)

          let valid = this.validateFile(file)
          if (valid) {
            this.$show_error_message(valid)
            return this.$log_error(valid)
          }
          let newFile = this.createFileHandler(file)
          if (newFile) {
            newFile.title = newFile.title?.replaceAll('=', '_') || '---'
            result.push(newFile)
          }
          return newFile
        })
        this.$emit('update:files', result)
        if (this.addFiles) {
          this.addFiles(new_files)
        }
      })
      document.body.appendChild(input)
      input.click()
    },
    deleteFile(n, file) {
      this.$emit('deleteFile', n, file)
    },
    restoreFile(n, file) {
      this.$emit('restoreFile', n, file)
    },
  },
  components: {
    DocumentList
  }
}
</script>
<style lang="scss" scoped>
.dropFile {
  height: max-content;
  min-height: 128px;
  background: var(--v-main__light_green-base);
  border: 2px dashed var(--secondary__green_not_active);
  box-sizing: border-box;
  border-radius: 4px;
  color: var(--black-color);
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  justify-content: center;
  cursor: default;
  margin: auto;
  &:hover, &.dragFileOver{
    background: var(--v-secondary__green_chosen-base);
  }
}
</style>
